import Vue from "vue";
import vueRwd from "./rwd";
import "@/directives/tableAdaptive";

Vue.use(vueRwd);
